import axios from 'axios';
import { Message } from 'element-ui';
// import router from './router'
console.log('当前环境变量：' + process.env.NODE_ENV);
console.log('当前环境路径：' + process.env.VUE_APP_URL);
const service = axios.create({
    // process.env.NODE_ENV === 'development' 来判断是否开发环境
    baseURL: process.env.VUE_APP_URL
    // timeout: 10000
});
service.interceptors.request.use(
    config => {
        if(localStorage.getItem('token')){
            config.headers['Authorization'] = localStorage.getItem('token')
        }
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);
service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            return Promise.resolve(response.data);
        } else {
            Promise.reject(response.data);
        }
    },
    error => {
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    Message.warning({
                        message: '即将重新登录',
                        center: true,
                        duration: 2000
                    });
                    // setTimeout(()=>{
                    //     router.replace({
                    //         path: '/login',
                    //         query: {redirect: router.currentRoute.fullPath}   //登录成功后跳入浏览的当前页面
                    //     })   
                    // },2200)         
                    break;
            }
            return
        }
        Message.error({
            message: error.message,
            center: true
        });
        return Promise.reject(error);
    }
);
export default service;